import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/pages/Home.vue'
import Contact from '../views/pages/Contact.vue'
import About from '../views/pages/About.vue'
import Apartments from '../views/pages/Appartments.vue' 
import Gallery from '../views/pages/Gallery.vue'
import Tips from '../views/pages/Tips.vue'
import LanguageLayout from '../layouts/LanguageLayout.vue'
import { detectLocale } from '../main'

const routes = [
  {
    path: '/',
    name: 'root',
    component: LanguageLayout
  },
  {
    path: '/en',
    component: LanguageLayout,
    children: [
      {
        path: '',
        name: 'home-en',
        component: Home
      },
      {
        path: 'contact',
        name: 'contact-en',
        component: Contact
      },
      {
        path: 'about',
        name: 'about-en',
        component: About
      },
      {
        path: 'apartments',
        name: 'apartments-en',
        component: Apartments
      },
      {
        path: 'gallery',
        name: 'gallery-en',
        component: Gallery
      },
      {
        path: 'gallery/:category',
        name: 'gallery-category-en',
        component: Gallery
      },
      {
        path: 'tips',
        name: 'tips-en',
        component: Tips
      }
    ]
  },
  {
    path: '/sk',
    component: LanguageLayout,
    children: [
      {
        path: '',
        name: 'home-sk',
        component: Home
      },
      {
        path: 'kontakt',
        name: 'contact-sk',
        component: Contact
      },
      {
        path: 'o-nas',
        name: 'about-sk',
        component: About
      },
      {
        path: 'apartmany',
        name: 'apartments-sk',
        component: Apartments
      },
      {
        path: 'galeria',
        name: 'gallery-sk',
        component: Gallery
      },
      {
        path: 'galeria/:category',
        name: 'gallery-category-sk',
        component: Gallery
      },
      {
        path: 'tipy',
        name: 'tips-sk',
        component: Tips
      }
    ]
  },
  {
    path: '/de',
    component: LanguageLayout,
    children: [
      {
        path: '',
        name: 'home-de',
        component: Home
      },
      {
        path: 'kontakt',
        name: 'contact-de',
        component: Contact
      },
      {
        path: 'uber-uns',
        name: 'about-de',
        component: About
      },
      {
        path: 'apartments',
        name: 'apartments-de',
        component: Apartments
      },
      {
        path: 'galerie',
        name: 'gallery-de',
        component: Gallery
      },
      {
        path: 'galerie/:category',
        name: 'gallery-category-de',
        component: Gallery
      },
      {
        path: 'tipps',
        name: 'tips-de',
        component: Tips
      }
    ]
  },
  {
    path: '/pl',
    component: LanguageLayout,
    children: [
      {
        path: '',
        name: 'home-pl',
        component: Home
      },
      {
        path: 'kontakt',
        name: 'contact-pl',
        component: Contact
      },
      {
        path: 'o-nas',
        name: 'about-pl',
        component: About
      },
      {
        path: 'apartamenty',
        name: 'apartments-pl',
        component: Apartments
      },
      {
        path: 'galeria',
        name: 'gallery-pl',
        component: Gallery
      },
      {
        path: 'galeria/:category',
        name: 'gallery-category-pl',
        component: Gallery
      },
      {
        path: 'porady',
        name: 'tips-pl',
        component: Tips
      }
    ]
  },
  {
    path: '/hu',
    component: LanguageLayout,
    children: [
      {
        path: '',
        name: 'home-hu',
        component: Home
      },
      {
        path: 'kapcsolat',
        name: 'contact-hu',
        component: Contact
      },
      {
        path: 'rolunk',
        name: 'about-hu',
        component: About
      },
      {
        path: 'apartmanok',
        name: 'apartments-hu',
        component: Apartments
      },
      {
        path: 'galeria',
        name: 'gallery-hu',
        component: Gallery
      },
      {
        path: 'galeria/:category',
        name: 'gallery-category-hu',
        component: Gallery
      },
      {
        path: 'tippek',
        name: 'tips-hu',
        component: Tips
      }
    ]
  },
  // Catch all route for unsupported paths
  {
    path: '/:pathMatch(.*)*',
    redirect: '/en'  // Redirect unknown paths to default locale
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard to handle root path and language detection
router.beforeEach(async (to, from, next) => {
  // Only handle the root path
  if (to.name === 'root') {
    try {
      // Wait for the locale detection
      const detectedLocale = await detectLocale();
      next(`/${detectedLocale}`);
    } catch (error) {
      console.error('Error detecting locale:', error);
      next('/en'); // Fallback to English on error
    }
  } else {
    const locale = to.path.split('/')[1] || 'sk';
    updateDocumentTitle(locale);
    next();
  }
});

function updateDocumentTitle(locale) {
  const titles = {
    'sk': 'Apartmány Danka',
    'en': 'Apartments Danka', 
    'de': 'Apartments Danka',
    'pl': 'Apartamenty Danka',
    'hu': 'Danka Apartmanok'
  };
  
  const title = titles[locale] || titles['sk'];
  document.title = title;
}

export default router 